import React, { useState, useEffect } from "react";
import { API_BASE } from "../../Utils/constant";
import { toast } from "react-toastify";
import useUserStore from "../../zustand-stores/UserStore";
import { AUTH_TOKEN } from "../../constants/localStorageKeys";
import { retrieve } from "../../helpers/StorageHelper";

const ContactUs = () => {
  const { user } = useUserStore();

  const [formData, setFormData] = useState({
    name: user?.full_name || "",
    email: user?.email || "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await fetch(`${API_BASE}/user/contact-us`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${retrieve(AUTH_TOKEN)}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Something went wrong");
        toast.error("Something went wrong!");
      }
      toast.success("Message sent successfully!");
      // setSuccess("Message sent successfully!");
      setFormData((prev) => ({ ...prev, message: "" }));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = formData.email && formData.message && formData.name;

  // message timeout after 2 sec
  useEffect(() => {
    if (success || error) {
      const timer = setTimeout(() => {
        if (success) setSuccess("");
        if (error) setError(null);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [success, error]);

  return (
    <div style={{ height: "100%" }}>
      <div className="profile-container">
        <h1 className="setting-header text-heading-h3 mb-3 mb-md-4">
          Contact us
        </h1>
        <form className="contact-us-form" onSubmit={handleSubmit}>
          <div className="row g-3 g-sm-4">
            <div className="col-md-6">
              <div className="textfield-1">
                <input
                  type="text"
                  className="text-body-b2"
                  name="name"
                  value={formData.name}
                  readOnly
                  required
                />
                <label className="text-body-b2">Your name</label>
              </div>
            </div>
            <div className="col-md-6">
              <div className="textfield-1">
                <input
                  type="email"
                  className="text-body-b2"
                  name="email"
                  value={formData.email}
                  readOnly
                  required
                />
                <label className="text-body-b2">Your email</label>
              </div>
            </div>
            <div className="col-md-12">
              <div className="textfield-1">
                <textarea
                  className="text-body-b2"
                  placeholder=""
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
                <label className="text-body-b2">Your message</label>
              </div>
            </div>
            {error && <p className="text-danger mt-2">{error}</p>}
            {success && <p className="text-success mt-2">{success}</p>}
            <div className="d-flex mt-6 ">
              <button
                type="submit"
                className="btn-1 btn-1-primary"
                style={{
                  maxWidth: "240px",
                  width: "100%",
                }}
                disabled={!isFormValid || loading}
              >
                {loading ? "Sending..." : "Send Now"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
